import { EInvoicingSetupStep } from '../types'

export const STEP_COUNT_MAP: Record<EInvoicingSetupStep, number> = {
  EMPTY_STATE: 1,
  COMPANY_INFO: 1,
  UPLOAD_DOCS: 2,
  UPLOAD_ID_FRONT: 2,
  UPLOAD_ID_BACK: 2,
  UPLOAD_PASSPORT: 2,
  FILES_SUCCESS: 3,
  SIGNATURE: 3,
}

export const MAX_STEP_COUNT = Object.values(STEP_COUNT_MAP).sort((a, b) => b - a)[0]
